<template>
  <div class="uploaderContainer">
    <div class="image-title">
      <h4 :class="[isRequired ? 'ivu-form-item-label' : '']">处方图片：</h4>
      <!-- <div> -->
        <div class="uploader" @click="$refs.file.click()" v-if="whetherUpload && able ">
          <input type="file" ref="file" @change="fileReader" v-show="false">
          <p>
            <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>{{whetherUpload && hasValidImgUrl > 0  ? '重新上传' : '点击上传'}}
          </p>
        </div>
      <!-- </div> -->
      <div class="uploader" v-if="hasValidImgUrl > 0" @click="handleImage('spin')">
        <p>
          <lk-icon type="ios-refresh-circle-outline" size="16"></lk-icon>旋转
        </p>
      </div>
    <div class="uploader" v-if="hasValidImgUrl > 0" @click="handleImage('enlarge')">
        <p>
          <lk-icon type="ios-add-circle-outline" size="16"></lk-icon>放大
        </p>
      </div>
      <div class="uploader" v-if="hasValidImgUrl > 0" @click="handleImage('narrow')">
        <p>
          <lk-icon type="ios-remove-circle-outline" size="16"></lk-icon>缩小
        </p>
      </div>
      <div class="uploader" v-if="isDelete" @click="handleImage('delete')">
        <p>
          <lk-icon type="ios-remove-circle-outline" size="16"></lk-icon>删除
        </p>
      </div>
    </div>
    <div
      v-if="hasValidImgUrl <= 0 && !whetherUpload"
      class="noImage">无处方图片
    </div>
    <div
      v-if="hasValidImgUrl <= 0 && isTmall"
      class="noImage">{{ imgText }}
    </div>
    <div
      class="detailContainer"
      ref="imageContainer"
    >
    <div id="imageCon" v-show="hasValidImgUrl > 0">
      <ul class="imgWrap" v-show="false">
        <li v-for="(item, index) in imageList" :key="index" >
          <img
          :src="decodeURIComponent(item)"
          alt="Picture  " />
        </li>
      </ul>
    </div>
    </div>
    <div class="botton-container">
       <lk-button @click="downLoadPDF" type='primary' :loading='downLoadLoading' class="picDownloadButton" v-if='showButton'>下载</lk-button>
      </div>
    <lk-Page
      :current="pageData.current"
      :page-size="1"
      :total="pageData.total"
      v-if="hasValidImgUrl > 0"
      simple
      @on-change="changePage"
      :class="'image-page'"
    />
    <!-- <lk-button class="replaceBtn" @click="toReplaceImg" v-if="isCanChange&&isNeedChange">替换</lk-button>
    <lk-modal v-model="replaceModal" title="替换处方" width='550' :closable="false"  :mask-closable="false">
      <div class="modelContent">
        <lk-form
          :label-width='120'
          label-position="right"
        >
          <lk-row>
            <lk-col>
              <lk-form-item label='上传新的处方图片:'>
                <Uploader style="width:250px" :able='true' v-model="theUploadImgUrl"></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button @click="handlerCancel">取消</lk-button>
        <lk-button :loading='confirmReceivedLoading' @click="confirmReceived" type='primary'>确定</lk-button>
      </div>
    </lk-modal> todo:dch-->
  </div>
</template>
<script>
import Viewer from 'viewerjs';
import upload from '../../services/upload';
import sale from '../../services/sale';
import Uploader from '../Uploader.vue';
import utils from '../../libs/utils';
import 'viewerjs/dist/viewer.css';

export default {
  name: 'uploader',
  components: {
    Uploader,
  },
  data() {
    return {
      confirmReceivedLoading: false,
      theUploadImgUrl: '',
      replaceModal: false,
      downLoadLoading: false,
      img: null, // viewerjs实例
      acciptList: [
        'image/png',
        'image/jpeg',
        'image/gif',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/wps-writer',
        'text/csv',
        'application/msword',
      ],
      picList: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp'],
      excList: ['', 'xls', 'xlsx'],
      wordList: ['doc', 'docx'],
      rotateNum: 0,
      loading: false,
      token: '',
      upImg: '',
      file: null,
      showImg: false,
      type: '',
      hasValidImgUrl: 0,
      currentImg: '', // 当前显示图片
      pageData: { // 分页数据
        current: 1,
        total: 5,
      },
      imageList: [],
    };
  },
  props: {
    name: {
      type: String,
      default: '上传',
    },
    icon: {
      type: String,
    },
    url: {
      type: [String, Array],
    },
    label: {
      type: String,
      default: '',
    },
    able: {
      type: Boolean,
      default: false,
    },
    isAbleUpload: {
      type: Boolean,
      default: false,
    },
    orderType: {
      type: Number,
    },
    format: {
      type: Array,
      default() {
        return [];
      },
    },
    maxSize: Number,
    sourceType: Number,
    epid: {},
    isNeedChange: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'url',
    event: 'change',
  },
  watch: {
    url(newVal) {
      let list = [];
      if (typeof newVal == 'string') {
        list.push(newVal);
      } else if (Array.isArray(newVal)) {
        list = newVal;
      }
      list = list.filter(s => s && s.trim());
      this.hasValidImgUrl = list.length;
      this.currentImg = list[0];
      this.pageData.current = 1;
      this.pageData.total = list.length;
      this.imageList = list;
      this.$nextTick(() => {
        this.initImg();
        if (this.whetherUpload) {
          this.imgUrl = list[0] ? decodeURIComponent(list[0]) : '';
          this.dynamicAddImg();
        }
      });
    },
  },
  computed: {
    isDelete() {
      return this.whetherUpload && this.hasValidImgUrl > 0 && this.able && this.isTmall;
    },
    whetherUpload() {
      return this.orderType === 5 || this.isAbleUpload || this.isTmall || this.isMeiXin;
    },
    isRequired() {
      return this.orderType === 5 || this.isTmall;
    },
    isTmall() {
      return [10, 13].indexOf(this.sourceType) >= 0;
    },
    imgText() {
      if (this.sourceType == 10) {
        return '请前往天猫审方后台下载处方后上传处方图片';
      }
      return '请前往京东审方后台下载处方后上传处方图片';
    },
    isCanChange() {
      if (typeof this.url === 'string' || (this.url instanceof Array && this.url.length)) {
        return true;
      }
    },
    isMeiXin() {
      return this.sourceType === 12;
    },
  },
  mounted() { },
  methods: {
    confirmReceived() {
      if (this.theUploadImgUrl == '') {
        this.$Message.error('请选择图片');
        return;
      }
      const params = {
        epId: this.epid,
        oldPicUrl: this.url[this.pageData.current - 1],
        newPicUrl: this.theUploadImgUrl,
      };
      sale.prescriptionReplacePic(params).then((res) => {
        if (res.data.status === 200) {
          const imgList = [];
          res.data.data.forEach((item) => {
            imgList.push(decodeURIComponent(item));
          });
          this.$emit('change', imgList);
          if (this.imgUrl) {
            const imgWrap = document.getElementsByClassName('imgWrap')[0];
            this.img.destroy();
            imgWrap.innerHTML = '';
          }
          this.replaceModal = false;
          this.theUploadImgUrl = '';
        } else {
          this.$Message.error(res.data.error);
        }
        this.confirmReceivedLoading = false;
      }).catch((err) => {
        this.confirmReceivedLoading = false;
        utils.handleError(err);
      });
    },
    handlerCancel() {
      this.replaceModal = false;
    },
    toReplaceImg() {
      this.replaceModal = true;
    },
    initImg() {
      const img = new Viewer(document.getElementById('imageCon'), {
        inline: true, // 内联模式
        backdrop: false, // 背景
        button: false, // 右上角全屏按钮
        navbar: false, // 底部图片缩略图
        title: false, // 图片信息
        maxZoomRatio: 2, // 最大放大倍数
        minZoomRatio: 0.1,
        zIndex: 1,
        click: true,
        toolbar: false,
      });
      this.img = img;
    },
    dynamicAddImg() {
      const imgWrap = document.getElementsByClassName('imgWrap')[0];
      const frag = document.createDocumentFragment();
      const li = document.createElement('li');
      const img = document.createElement('img');
      img.src = this.imgUrl;
      li.appendChild(img);
      frag.appendChild(li);
      imgWrap.append(frag);
      this.img.view(0).update();
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },
    /**
     * @param {string} type spin旋转 enlarge放大 narrow缩小
     */
    handleImage(type) {
      if (type === 'spin') {
        this.img.rotate(90);
      }
      if (type === 'enlarge') {
        this.img.zoom(0.1, true);
      }
      if (type === 'narrow') {
        this.img.zoom(-0.1, true);
      }
      if (type === 'delete') {
        const imgWrap = document.getElementsByClassName('imgWrap')[0];
        this.img.destroy();
        imgWrap.innerHTML = '';
        this.url = '';
        this.$emit('change', []);
      }
    },
    changePage(e) {
      const num = e - this.pageData.current;
      for (let index = 0; index < Math.abs(num); index++) {
        if (num > 0) {
          this.img.next(true);
        } else if (num < 0) {
          this.img.prev(true);
        }
      }
      this.pageData.current = e;
    },
    fileReader(e) {
      this.loading = true;
      const fr = new FileReader();
      this.file = e.target.files[0];
      const typeName = this.file.name.slice(
        this.file.name.lastIndexOf('.') + 1,
      );
      const typeNameLower = typeName.toLowerCase();
      const defaultFormatLList = [
        ...this.picList,
        ...this.excList,
        ...this.wordList,
        'pdf',
      ];
      let fileFlag = false; // 是否符合上传规则
      if (this.format.length) {
        // 如果传递了format, 则只根据扩展名称进行判断
        fileFlag = this.format.includes(typeNameLower);
      } else if (
        this.acciptList.includes(this.file.type)
        || defaultFormatLList.includes(typeNameLower)
      ) {
        fileFlag = true;
      }
      // 不符合上传规则
      if (!fileFlag) {
        this.file = null;
        this.$refs.file.value = '';
        this.$Message.error('不支持该文件上传，请更换文件');
        return;
      }

      // 检查文件是否超限
      if (this.maxSize) {
        if (this.file.size > this.maxSize * 1024 * 1024) {
          this.file = null;
          this.$refs.file.value = '';
          this.$Message.error(`文件超过${this.maxSize}M限制，请更换文件`);
          return false;
        }
      }
      // 选择文件中的头一个开始读取,将img读取为base64编码可以被img直接解析
      fr.readAsDataURL(e.target.files[0]);
      fr.onload = () => {
        this.handleUpload(this.file.name);
        e.target.value = null; // 解决change事件重复选择同一文件是不能重新渲染载入事件
      };
      if (this.imgUrl) {
        const imgWrap = document.getElementsByClassName('imgWrap')[0];
        this.img.destroy();
        imgWrap.innerHTML = '';
      }
    },
    async getToken(name) {
      return new Promise((resolve) => {
        upload
          .getToken(name)
          .then((res) => {
            if (res.data.status === 200) {
              resolve(res.data.data);
            } else {
              this.loading = false;
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            this.loading = false;
            utils.handleError(err);
          });
      });
    },
    async handleUpload(name) {
      const token = await this.getToken(name);
      token.host = `${window.location.protocol}//${token.host}`;

      upload
        .upload(this.file, token)
        .then((res) => {
          if (res.status === 200) {
            this.$Message.success('上传成功');
            upload
              .getFile({
                bucket: token.bucket,
                objectName: token.dir + token.objectName,
              })
              .then((innerRes) => {
                if (innerRes.data.status === 200) {
                  this.url = encodeURIComponent(innerRes.data.data);
                  this.$emit('change', [this.url]);
                  this.dispatch(
                    'FormItem',
                    'on-form-change',
                    encodeURIComponent(innerRes.data.data),
                  );
                } else {
                  this.loading = false;
                  this.$Message.error(innerRes.data.error);
                }
              })
              .catch((err) => {
                this.loading = false;
                utils.handleError(err);
              });
          } else {
            this.loading = false;
            this.$Message.error('上传失败');
          }
        })
        .catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
    },
    downLoadPDF() {
      window.open(decodeURIComponent(this.imageList[this.pageData.current - 1]));
    },
  },
};
</script>
<style lang="less" scoped>
.replaceBtn {
  margin-top: 20px;
}
.uploaderContainer {
  position: relative;
  height: 100%;
  width: 100%;
  margin-bottom: 10px;
  .image-title {
    display: flex;
    align-items: center;
    padding: 10px;
    height: 48px;
    width: 100%;
  }
}
.uploader {
  height: 28px;
  border: 1px dashed #dedede;
  text-align: center;
  position: relative;
  cursor: pointer;
  line-height: 1.2;
  margin-right: 10px;
  p {
    // padding-right: 10px;
    line-height: 28px;
    font-size: 12px;
  }
}
.fileHolder {
  height: 28px;
  display: flex;
  align-items: center;
  position: relative;
}
.cover {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 16px;
      margin-right: 8px;
      // color: #1890FF
    }
  }
  .del {
    display: none;
    cursor: pointer;
  }
  // height: 80px;
  // background: #000;
  // text-align: right
  // opacity: 0;
}

.cover:hover {
  // opacity: 1;
  background: #f5f5f5;
  .del {
    display: block;
  }
}

.detailContainer {
  overflow: scroll;
  padding: 0 10px;
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  .uploader-image {
    position: absolute;
    transform-origin: center;
    width: 100%;
    height: 100%;
  }
  #imageCon {
    width: 100%;
    ul {
      display: flex;
    }
  }
}
.noImage {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-page {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
}
.ivu-form-item-label:before {
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 12px;
  color: #ed4014;
}
.picDownloadButton{
  position: absolute;
  right: 150px;
  top: 583px;
}
</style>
